{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Plantillas",
    "DESCRIPTION": "Consulta las plantillas de mensajes sincronizadas desde tus bandejas de entrada de WhatsApp. Para crear o editar una plantilla, gestiónala con tu proveedor.",
    "COUNT": "{n} plantilla | {n} plantillas",
    "LEARN_MORE": "Más información sobre las plantillas de WhatsApp",
    "SYNC_TEMPLATES": "Sincronizar plantillas",
    "SYNC_SUCCESS": "Se inició la sincronización de plantillas para todas las bandejas de entrada de WhatsApp. Los cambios pueden tardar unos minutos.",
    "PARTIAL_SYNC_ERROR": "Se inició la sincronización de plantillas para algunas bandejas de entrada de WhatsApp, pero no se pudo sincronizar el resto.",
    "SYNC_ERROR": "No se pudo iniciar la sincronización de plantillas. Inténtalo de nuevo.",
    "SEARCH_PLACEHOLDER": "Buscar por contenido o nombre...",
    "MANAGE_IN_META": "Gestionar en Meta",
    "LOADING": "Cargando plantillas de WhatsApp...",
    "EMPTY": "No se encontraron plantillas de WhatsApp.",
    "NO_RESULTS": "Ninguna plantilla coincide con tus filtros.",
    "FETCH_ERROR": "No se pudieron cargar las plantillas de WhatsApp. Inténtalo de nuevo.",
    "PARTIAL_FETCH_ERROR": "Algunas plantillas de WhatsApp no se pudieron cargar. Inténtalo de nuevo.",
    "LAST_SYNC_ATTEMPT": "Último intento de sincronización el {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "No enviada para aprobación de WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Todas las bandejas de entrada",
      "ALL_LANGUAGES": "Todos los idiomas",
      "ALL_TYPES": "Todos los tipos"
    },
    "TYPES": {
      "TEXT": "Texto",
      "IMAGE": "Imagen",
      "VIDEO": "Video",
      "DOCUMENT": "Documento",
      "CALL_TO_ACTION": "Llamada a la acción",
      "COPY_CODE": "Copiar código"
    },
    "PREVIEW": {
      "TITLE": "Vista previa de la plantilla",
      "DESCRIPTION": "Vista previa de cómo aparece esta plantilla en WhatsApp.",
      "OPEN": "Vista previa de {name}",
      "CLOSE": "Cerrar vista previa",
      "DETAILS": "Detalles de la plantilla",
      "STATUS": "Estado",
      "TYPE": "Tipo de contenido",
      "CATEGORY": "Categoría",
      "LANGUAGE": "Idioma",
      "INBOXES": "Bandejas de entrada"
    }
  }
}
